import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { fetchSettings, restartService, setSecret } from "../api/settings";

export function useSettings() {
  return useQuery({ queryKey: ["settings"], queryFn: fetchSettings });
}

export function useSetSecret() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, value }: { key: string; value: string }) => setSecret(key, value),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["settings"] }),
  });
}

export function useRestartService() {
  return useMutation({ mutationFn: (service: string) => restartService(service) });
}
